// @flow

import {toast} from "react-toastify"

import {get, put} from "../client"
import i18n from "../i18n"
import type {
  User,
  UserPasswordEdit,
  ThunkAction,
  Action,
  Dispatch,
} from "../types"

export const fetchUser = (): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get("/user").then((response) => {
      // toast.success('toast.user.fetch.success')
      return dispatch(setUser(response.data))
    })
  }
}

export const setUser = (user: User): Action => ({
  type: "SET_USER",
  user,
})

export const updatePassword = (edit: UserPasswordEdit): ThunkAction => {
  return () => {
    return put("/user", edit).then((response) => {
      if (response.errors) {
        // TODO set errors
        toast.error(i18n.t("toast.user.updatePassword.error"))
      } else {
        // TODO set success ?
        toast.success(i18n.t("toast.user.updatePassword.success"))
      }
    })
  }
}
